import { withNamespaces } from "react-i18next";
import { Alert, Card, CardBody } from "reactstrap";
import { useDsrDeadlineWorkflow } from "../deadline-management/hooks/useDsrDeadlineWorkflow";
import HistoryPeriod from "./components/history-period";
import { useDsrDeadlineHistory } from "./hooks/useDsrDeadlineHistory";

const DeadlineHistory = ({ t, caseId }) => {
  const { isFeatureEnabled, isDeadlineManagementEnabled, isLoading } =
    useDsrDeadlineWorkflow(caseId);
  const historyQuery = useDsrDeadlineHistory(
    caseId,
    isDeadlineManagementEnabled
  );
  const periods = Array.isArray(historyQuery.data) ? historyQuery.data : [];

  if (!isFeatureEnabled) {
    return null;
  }

  if (isLoading || (isDeadlineManagementEnabled && historyQuery.isLoading)) {
    return (
      <div
        className="dt-field dt-skeleton"
        style={{ width: "100%", height: "220px" }}
      />
    );
  }

  if (!isDeadlineManagementEnabled) {
    return null;
  }

  if (historyQuery.isError) {
    return (
      <Alert color="warning" className="mb-0">
        {t("An error occurred while fetching deadline history.")}
      </Alert>
    );
  }

  return (
    <div className="dsr-deadline-cards">
      <Card className="dsr-deadline-card">
        <CardBody>
          <h6 className="dsr-deadline-card__title">{t("Deadline History")}</h6>
          <p className="dsr-deadline-card__note mb-3">
            {t("A record of deadline-related actions for this request.")}
          </p>

          {periods.length === 0 ? (
            <p className="dsr-deadline-card__value mb-0">
              {t("No deadline actions have been recorded.")}
            </p>
          ) : (
            periods.map((period) => (
              <HistoryPeriod key={period.id} period={period} />
            ))
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default withNamespaces()(DeadlineHistory);
